var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Component from 'vue-class-component';
import IVueDialog from "@/interface/IVueDialog";
import AccoutCheckService from '../../../api/AccoutCheckService';
import { Loading } from 'element-ui';
var SignDialog = (function (_super) {
    __extends(SignDialog, _super);
    function SignDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isForceSign = false;
        _this.selectRows = [];
        _this.step = 1;
        _this.hisSign = '';
        return _this;
    }
    SignDialog.prototype.reSign = function () {
        this.step = 2;
    };
    SignDialog.prototype.preSign = function () {
        this.step = 1;
    };
    SignDialog.prototype.created = function () {
        var _this = this;
        this.service = AccoutCheckService.getInstance();
        (this.selectRows || []).forEach(function (item) {
            if (item.statement_order_force_confirm && item.statement_order_force_confirm == true) {
                _this.isForceSign = true;
                return;
            }
        });
        this.getLastSignImg();
    };
    SignDialog.prototype.getLastSignImg = function () {
        var _this = this;
        this.service.latestSignImg({}).then(function (res) {
            _this.hisSign = res.data.data.url;
            if (_this.hisSign === '') {
                _this.step = 2;
            }
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    SignDialog.prototype.submit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var orderIds, _a, success, data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.step == 2)) return [3, 2];
                        orderIds = this.selectRows.map(function (item) { return item.order_id; });
                        return [4, this.service.getSignStatus({ order_ids: orderIds.join(',') })];
                    case 1:
                        _a = (_b.sent()).data, success = _a.success, data = _a.data;
                        if (success && data.sign_status) {
                            this.$message.success('签字成功');
                            this.$closeDialog();
                            this.$emit('submitSuccess');
                        }
                        else {
                            this.$message.warning('未获取签字信息，请重新扫码签字');
                        }
                        return [3, 3];
                    case 2:
                        this.confirm(null, 1);
                        _b.label = 3;
                    case 3: return [2];
                }
            });
        });
    };
    SignDialog.prototype.jump = function () {
        this.confirm(1, null);
    };
    SignDialog.prototype.confirm = function (sign_confirm, use_latest_sign) {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        var param = { order_id: (this.selectRows.map(function (item) { return item.order_id; }).join(",")) };
        if (sign_confirm && sign_confirm == 1) {
            param = Object.assign(param, {
                sign_confirm: 1
            });
        }
        if (use_latest_sign && use_latest_sign == 1) {
            param = Object.assign(param, {
                use_latest_sign: 1
            });
        }
        this.service.confirm(param).then(function (res) {
            loadingInstance.close();
            var _a = res.data, code = _a.code, data = _a.data;
            if (res.data.code == 76) {
                _this.$message.error(res.data.msg);
                _this.$emit('submitSuccess');
                _this.$closeDialog();
            }
            else {
                _this.$message.success('操作成功');
                _this.$emit('submitSuccess');
                _this.$closeDialog();
            }
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    SignDialog = __decorate([
        Component({})
    ], SignDialog);
    return SignDialog;
}(IVueDialog));
export default SignDialog;
